/**
 * Invalid configuration error.
 * This error is thrown when the Branding messes up with an ngConstant.
 *
 * @alias TmrChecklistNotFoundError
 * @type {ngFactory}
 */
export const factory = [
  'TmrInvalidConfigurationError',
  /*@ngInject*/ TmrError =>
    class TmrInvalidConfigurationError extends TmrError {},
]
